import React, { useEffect, useState } from "react";
import { Button, Card, Col, Divider, Modal, Row, Tag, message } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import ConfirmVote from "../../../../helpers/cards-helper/ConfirmVote";
import { ErrorCard } from "../../Patronage/PatronageReferred/voters-list/components/List";
import { useSelector } from "react-redux";
import ConfirmDelete from "../../../../helpers/cards-helper/ConfirmDelete";
import PatronagerService from "../../../../services/Election/Patronage/PatronagerService";
import { filterDataByName, filterDataBySurname, setRowNumber } from "../../../../helpers/MainHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";




const filterItems = (items, filters) => {
    let filteredItems = items;

    if (filters?.name) {
        filteredItems = filterDataByName(filteredItems, filters.name);
    }

    if (filters?.surname) {
        filteredItems = filterDataBySurname(filteredItems, filters.surname);
    }

    if (filters?.listNumber) {
        filteredItems = filteredItems.filter((item) => item?.list_number === parseInt(filters.listNumber));
    }

    return setRowNumber(filteredItems);
};


const updateVoters = (dispatch, items, patronagerVoterId, hasVoted) => {
    const updatedItems = items?.map((item) => {
        return {
            ...item,
            voted: item?.patronager_voter_id === patronagerVoterId ? hasVoted : item?.voted
        };
    });

    const action = {
        type: "set_items",
        payload: {
            items: updatedItems,
            count: updatedItems?.length
        }
    };
    dispatch(action);
};



const VotersList = ({ dispatch, items, initialFilters, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [dataSource, setDataSource] = useState(items);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modalResetNumber, setModalResetNumber] = useState({ confirmModal: 0, deleteModal: 0 });


    useEffect(() => {
        let filteredItems = items;
        if (initialFilters) {
            filteredItems = filterItems(items, initialFilters);
        }
        setDataSource(setRowNumber(filteredItems));
    }, [initialFilters, items]);


    const showConfirmModal = (item) => {
        setItem(item);
        setConfirmModal(true);
    };


    const closeConfirmModal = () => {
        setConfirmModal(false);
        setModalResetNumber({
            confirmModal: modalResetNumber.confirmModal + 1
        });
        setItem(null);
    };


    const showDeleteModal = (item) => {
        setItem(item);
        setDeleteModal(true);
    };


    const closeDeleteModal = () => {
        setDeleteModal(false);
        setModalResetNumber({
            deleteModal: modalResetNumber.deleteModal + 1
        });
        setItem(null);
    };


    const onConfirm = () => {
        setLoading(true);
        const patronagerVoterId = item?.patronager_voter_id;
        PatronagerService.confirmVote(token, patronagerVoterId)
            .then((response) => {
                message.success("Konfirmimi u krye me sukses!", 1)
                    .then(() => {
                        updateVoters(dispatch, items, patronagerVoterId, true);
                        setLoading(false);
                    });
                closeConfirmModal();
            })
            .catch((err) => {
                const errorMessage = getErrorMessage(err);
                message.error(errorMessage, 2);
                closeConfirmModal();
                setLoading(false);
            });
    };


    const onDelete = () => {
        setLoading(true);
        const patronagerVoterId = item?.patronager_voter_id;
        PatronagerService.deleteVote(token, patronagerVoterId)
            .then((response) => {
                message.success("Fshirja u krye me sukses!", 1)
                    .then(() => {
                        updateVoters(dispatch, items, patronagerVoterId, false);
                        setLoading(false);
                    });
                closeDeleteModal();
            })
            .catch((err) => {
                const errorMessage = getErrorMessage(err);
                message.error(errorMessage, 2);
                closeConfirmModal();
                closeDeleteModal(false);
            });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>

                {dataSource?.length === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Card>
                                <ErrorCard
                                    message={"Nuk ka votues!"}
                                />
                            </Card>
                        </Col>
                    </Row>
                )}

                {dataSource?.length > 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Card bodyStyle={{ padding: "0px" }} style={{ borderRadius: "0" }}>
                                <Row gutter={24} className="p-2">
                                    <Col xl={2} lg={2} md={2} sm={2} xs={2} className="font-weight-bold text-center">
                                        #
                                    </Col>
                                    <Col xl={13} lg={13} md={13} sm={13} xs={13} className="font-weight-bold">
                                        Votuesi
                                    </Col>
                                    <Col xl={5} lg={5} md={5} sm={5} xs={5} className="font-weight-bold text-center">
                                        Nr. liste
                                    </Col>
                                    <Col xl={4} lg={4} md={4} sm={4} xs={4} className="font-weight-bold text-center">
                                        Votoi
                                    </Col>
                                </Row>

                                {dataSource?.map((elm, index) => (
                                    <Row gutter={24} key={index}>
                                        <Col span={24}>
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Divider className="w-100 mt-0 mb-0" />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} className="p-2">
                                                <Col xl={2} lg={2} md={2} sm={2} xs={2} className="font-weight-bold text-center">
                                                    {index + 1}.
                                                </Col>
                                                <Col xl={13} lg={13} md={13} sm={13} xs={13}>
                                                    {elm?.name + " " + elm?.father_name + " " + elm?.surname}
                                                </Col>
                                                <Col xl={5} lg={5} md={5} sm={5} xs={5} className="text-center">
                                                    {elm?.list_number}
                                                </Col>
                                                <Col xl={4} lg={4} md={4} sm={4} xs={4} className="text-center">

                                                    {elm?.voted === true && (
                                                        <Tag className="m-0" color="green">PO</Tag>
                                                    )}

                                                    {elm?.voted === false && (
                                                        <Tag className="m-0" color="magenta">JO</Tag>
                                                    )}

                                                </Col>
                                            </Row>

                                            {elm?.voted === true && (
                                                <Row gutter={24} className="p-2">
                                                    <Col xl={20} lg={20} md={20} sm={20} xs={20} />
                                                    <Col xl={4} lg={4} md={4} sm={0} xs={0} className="text-center">
                                                        <Button
                                                            block
                                                            danger
                                                            onClick={() => showDeleteModal(elm)}
                                                            icon={<CloseOutlined />}
                                                        >
                                                            Fshi
                                                        </Button>
                                                    </Col>
                                                    <Col xl={0} lg={0} md={0} sm={4} xs={4} className="text-center">
                                                        <Button
                                                            block
                                                            danger
                                                            onClick={() => showDeleteModal(elm)}
                                                            icon={<CloseOutlined />}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}

                                            {elm?.voted === false && (
                                                <Row gutter={24} className="p-2">
                                                    <Col xl={20} lg={20} md={20} sm={20} xs={20} />
                                                    <Col xl={4} lg={4} md={4} sm={0} xs={0} className="text-center">
                                                        <Button
                                                            block
                                                            type="primary"
                                                            onClick={() => showConfirmModal(elm)}
                                                            icon={<PlusOutlined />}
                                                        >
                                                            Konfirmo
                                                        </Button>
                                                    </Col>
                                                    <Col xl={0} lg={0} md={0} sm={4} xs={4} className="text-center">
                                                        <Button
                                                            block
                                                            type="primary"
                                                            onClick={() => showConfirmModal(elm)}
                                                            icon={<PlusOutlined />}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}

                                        </Col>
                                    </Row>
                                ))}

                            </Card>
                        </Col>
                    </Row>
                )}

                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Jeni duke konfirmuar votën e votuesit!"}
                            centered
                            visible={confirmModal}
                            closable={true}
                            onCancel={closeConfirmModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <ConfirmVote
                                title={"Jeni të sigurtë që votuesi:"}
                                fullName={item?.name + " " + item?.surname}
                                loading={loading}
                                onOk={onConfirm}
                                onCancel={closeConfirmModal}
                            />
                        </Modal>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Jeni duke fshirë votën e votuesit!"}
                            centered
                            visible={deleteModal}
                            closable={true}
                            onCancel={closeDeleteModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <ConfirmDelete
                                title={"Jeni të sigurtë që doni të fshini votën për votuesin:"}
                                fullName={item?.name + " " + item?.surname}
                                loading={loading}
                                onOk={onDelete}
                                onCancel={closeDeleteModal}
                            />
                        </Modal>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default VotersList;